var map = {
	"./League.vue": [
		"ce58",
		"chunk-39675c81",
		"chunk-5d625d7e"
	],
	"./Leagues.vue": [
		"06ec",
		"chunk-39675c81",
		"chunk-2b6aa346"
	],
	"./SeasonCalendar.vue": [
		"8282",
		"chunk-39675c81",
		"chunk-2d2fef70"
	],
	"./Team.vue": [
		"0767",
		"chunk-39675c81",
		"chunk-1ed2f7db"
	],
	"./Wait.vue": [
		"235a",
		"chunk-e519a95a"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;